/**
 * Enum of metadata `id` values assigned to Zod schemas in this library.
 */
export enum ZodSchemaId {
  /** Metadata id for {@link PrincipalTextSchema}. */
  PrincipalText = "PrincipalText",
  /** Metadata id for {@link PrincipalSchema}. */
  Principal = "Principal",
  /** Metadata id for {@link Uint8ArraySchema}. */
  Uint8Array = "Uint8Array",
  /** Metadata id for {@link UrlSchema}. */
  Url = "Url",
}
